import { Box } from "@mui/material";
import { Buffer } from "buffer";
import React from "react";
import { environment } from "../utils/environment";
import { RedirectController, RedirectControllerDelegate } from "./controller";
import styles from './styles.module.css';

export default class Redirect extends React.PureComponent implements RedirectControllerDelegate {

  private controller: RedirectController;

  constructor(props: any) {
    super(props);

    this.controller = new RedirectController(this);
  }

  authenticationFailed(): void {
    window.location.href = decodeURIComponent(environment.baseUrl);
  }

  authenticationSuccess(access: string, refresh: string): void {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const state = decodeURIComponent(params.get("state") || "");

    const decodedState = state && Buffer.from(state, "base64").toString("utf8")

    const jsonState = decodedState ? JSON.parse(decodedState): {url: environment.baseUrl}

    localStorage.setItem("AccessToken", access);
    localStorage.setItem("RefreshToken", refresh);
    
    window.location.href = decodeURIComponent(jsonState.url);
  }

  componentDidMount(): void {
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const token = params.get("token")!;
    this.controller.authenticateUser(token);
  }


  render() {
    return (
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="center"
        justifyContent="center"
        height="100vh"
      >
        <div className={ styles.loader } />
      </Box>
    )
  }
}
